export const SolutionServiceContainer = (position: 'left' | 'right') => {
  const positionStyle = position === 'left' ? 'md:flex-row' : 'md:flex-row-reverse';
  return `w-full py-[32px] md:py-10 px-5 md:px-[64px] flex flex-col md:flex-row items-center justify-center gap-[32px] md:gap-[64px] ${positionStyle}`;
};

export const ServiceName = 'text-[18px] md:text-[24px] tracking-[-0.09px] md:tracking-[-0.12px] font-bold leading-[120%]';
export const ServiceNameTextStyle = (serviceColor: string) => {
  return {
    color: serviceColor
  } as React.CSSProperties;
};

export const ServiceTitle = 'mt-[8px] md:mt-[14px] text-black text-[28px] md:text-[42px] leading-[130%] md:leading-[120%] tracking-[-0.42px] md:tracking-[-0.84px] not-italic font-bold';

export const ServiceDescription =
  'mt-[16px] md:mt-[24px] text-[rgba(0,0,0,0.55)] md:font-normal text-[16px] md:text-[20px] tracking-[-0.08px] md:tracking-[-0.1px] not-italic font-medium leading-[145%]';

export const Button = 'mt-[40px] md:mt-[48px] py-3 px-4 w-full md:w-fit bg-[#131313] text-white rounded-[12px] text-center';
